export const WITHDRAWAL = 'WITHDRAWAL';
export const WITHDRAWAL_FAILED = 'WITHDRAWAL_FAILED';
export const WITHDRAWAL_SUCCEED = 'WITHDRAWAL_SUCCEED';

export const WITHDRAWAL_CUSTOM = 'WITHDRAWAL_CUSTOM';
export const WITHDRAWAL_CUSTOM_FAILED = 'WITHDRAWAL_CUSTOM_FAILED';
export const WITHDRAWAL_CUSTOM_SUCCEED = 'WITHDRAWAL_SUCCEED';

export const FETCH_WITHDRAWAL_HISTORY = 'FETCH_WITHDRAWAL_HISTORY';
export const FETCH_WITHDRAWAL_HISTORY_FAILED = 'FETCH_WITHDRAWAL_HISTORY_FAILED';
export const FETCH_WITHDRAWAL_HISTORY_SUCCEED = 'FETCH_WITHDRAWAL_HISTORY_SUCCEED';

export const FETCH_USER_VOLUME_24H = 'FETCH_USER_VOLUME_24H';
export const FETCH_USER_VOLUME_24H_FAILED = 'FETCH_USER_VOLUME_24H_FAILED';
export const FETCH_USER_VOLUME_24H_SUCCEED = 'FETCH_USER_VOLUME_24H_SUCCEED';

export const WS_EVENT_USER_TRANSACTION = 'WS_EVENT_USER_TRANSACTION';
